/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

import * as actions from './actions';
import { ofType } from 'redux-observable';
import { map, mergeMap, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import webApi from '../../../Lib/WebApi';
import { addErrorNotice, callApi, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';

//params from state using:

export const getImportedWorksheet = (action$, state$) =>
  action$.pipe(
    ofType(actions.IMPORT_WORKSHEET_UPDATE_SEARCH),

    mergeMap((action) => {
      //extract parameters for the search from current state
      const {
        importFromThisSample,
        importFromSpecificSample,
        importFromSpecificTest,
        testMethodIds,
        thisSampleId,
        selectedSample = {},
        testSelection = {},
      } = state$.value.importedWorksheet[action.id];

      const sampleId = importFromThisSample
        ? thisSampleId
        : importFromSpecificSample
        ? selectedSample && selectedSample.Id
        : null;
      const worksheetId = importFromSpecificTest && testSelection?.Id;
      const canSearch = !!sampleId || !!worksheetId;
      if (!canSearch) {
        return [actions.updateImportedWorksheetSearchResolve(action.id, null)];
      }

      return callApi(
        !!worksheetId
          ? webApi.worksheets.get({
              worksheetId,
              expandBody: false,
            })
          : webApi.worksheets.query.get({
              sampleId,
              worksheetTypeId: testMethodIds,
              limit: 1,
              expandBody: false,
              includeImportOnlyWorksheets: true,
            })
      ).pipe(
        map(({ Body }) => {
          const worksheet = !!worksheetId ? Body : Body?.Worksheets?.find(() => true);
          //first worksheet if there is one, or null if an empty array/null was returned
          return actions.updateImportedWorksheetSearchResolve(action.id, worksheet || null);
        }),
        catchWithAuthErrors((err) =>
          of(actions.updateImportedWorksheetSearchReject(action.id), addErrorNotice('Failed to get worksheet.', err))
        )
      );
    })
  );

export const init = (action$) =>
  action$.pipe(
    ofType(actions.IMPORT_WORKSHEET_INIT),
    filter((action) => (action.params && action.params.selectedTestId ? true : false)),
    mergeMap((action) =>
      callApi(webApi['worksheets'].get({ worksheetId: action.params.selectedTestId, expandBody: false })).pipe(
        map(({ Body }) => actions.initImportedWorksheetResolve(action.id, Body || null)),
        catchWithAuthErrors((err) =>
          of(actions.updateImportedWorksheetSearchReject(action.id), addErrorNotice('Failed to get worksheet.', err))
        )
      )
    )
  );
